const watchIsFilterActive = {
    watch: {
        isFilterActive: {
            handler(isActive, wasActive) {
                if (isActive !== wasActive) {
                    this.$emit('change-active', isActive);
                }
            },
            immediate: true
        }
    }
};

export { watchIsFilterActive };
